import React from "react";
import "./ContactMeButton.css";
import { contactInfo } from "../../portfolio";

const onMouseEnter = (event, color, hoverBackgroundColor) => {
  const el = event.target;
  el.style.color = color;
  el.style.backgroundColor = hoverBackgroundColor;
};

const onMouseOut = (event, color, bgColor) => {
  const el = event.target;
  el.style.color = color;
  el.style.backgroundColor = bgColor;
};

export default function ContactMeButton({
  text,
  className,
  href,
  newTab,
  theme,
  backgroundColor,
  hoverBackgroundColor,
  textColor,
}) {
  return (
    <div className={className}>
      <a
        className="contact-me-button"
        href={"mailto:" + contactInfo.email_address}
        target="_blank"
        rel="noopener noreferrer"
        style={{
          color: textColor,
          backgroundColor: backgroundColor,
          border: `solid 1px ${theme.text}`,
        }}
        onMouseEnter={(event) =>
          onMouseEnter(event, textColor, hoverBackgroundColor)
        }
        onMouseOut={(event) => onMouseOut(event, textColor, backgroundColor)}
      >
        {text}
      </a>
    </div>
  );
}
